import { render } from "./JobPostDetails.vue?vue&type=template&id=c8130712&scoped=true"
import script from "./JobPostDetails.vue?vue&type=script&lang=js"
export * from "./JobPostDetails.vue?vue&type=script&lang=js"

import "./JobPostDetails.vue?vue&type=style&index=0&id=c8130712&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8130712"]])

export default __exports__